import { STATS, ADVANTAGES, SITE } from '@/data/site'
import { PageHero } from '@/components/PageHero'
import { SectionHeading } from '@/components/SectionHeading'
import { Icon } from '@/components/Icon'
import { CTA } from '@/components/sections/CTA'
import { useReveal } from '@/hooks/useReveal'

export default function About() {
  const statsRef = useReveal<HTMLDivElement>()
  const valuesRef = useReveal<HTMLDivElement>()
  const companyRef = useReveal<HTMLDivElement>()

  return (
    <>
      <PageHero
        eyebrow="关于我们"
        title="专注增值电信业务的专业服务商"
        description="依法合规经营，为企业客户提供可靠、高效的互联网信息服务与技术支持。"
      />

      <section className="section about-mission">
        <div className="container about-grid">
          <div className="about-content">
            <span className="eyebrow reveal">公司简介</span>
            <h2 className="about-title reveal delay-1">
              专注增值电信，
              <br />
              合规<span className="gradient-text">稳健经营</span>
            </h2>
            <p className="about-desc reveal delay-2">
              {SITE.companyName}成立于 2017 年，注册地位于江苏省镇江市。公司依法经营增值电信业务，
              依托专业团队与完善的服务体系，为企业客户提供合规、可靠、高效的互联网信息服务。
            </p>
            <p className="about-desc reveal delay-2">
              我们秉持合规为本、服务为先的理念，通过稳定的技术平台与贴心的运维支持，
              助力客户顺利开展互联网业务，实现长期稳健发展。
            </p>
          </div>

          <div className="about-stats" ref={statsRef}>
            {STATS.map((s) => (
              <div key={s.label} className="about-stat-card reveal">
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
            <div className="about-stats-note">
              <span className="about-stats-pulse" />
              持续为客户创造长期价值
            </div>
          </div>
        </div>
      </section>

      <section className="section company-info">
        <div className="container">
          <SectionHeading
            eyebrow="工商信息"
            title="依法合规，稳健经营"
            description="以下为企业工商登记信息，欢迎查询验证。"
          />
          <div className="company-info-grid" ref={companyRef}>
            <div className="company-info-item reveal">
              <span className="company-info-label">统一社会信用代码</span>
              <strong>{SITE.legal.creditCode}</strong>
            </div>
            <div className="company-info-item reveal delay-1">
              <span className="company-info-label">法定代表人</span>
              <strong>{SITE.legal.legalPerson}</strong>
            </div>
            <div className="company-info-item reveal delay-2">
              <span className="company-info-label">注册资本</span>
              <strong>{SITE.legal.registeredCapital}</strong>
            </div>
            <div className="company-info-item reveal delay-3">
              <span className="company-info-label">成立日期</span>
              <strong>{SITE.legal.foundedAt}</strong>
            </div>
            <div className="company-info-item company-info-item-wide reveal delay-1">
              <span className="company-info-label">注册地址</span>
              <strong>{SITE.legal.address}</strong>
            </div>
            <div className="company-info-item company-info-item-wide reveal delay-2">
              <span className="company-info-label">经营范围</span>
              <strong>{SITE.legal.businessScope}</strong>
            </div>
          </div>
        </div>
      </section>

      <section className="section about-values-sec">
        <div className="container">
          <SectionHeading
            eyebrow="服务优势"
            title="为什么选择我们"
            description="资质合规、服务稳定、响应贴心，为您的业务保驾护航。"
          />
          <div className="values-grid" ref={valuesRef}>
            {ADVANTAGES.map((v, i) => (
              <div key={v.title} className={`value-card reveal delay-${(i % 3) + 1}`}>
                <div className="value-card-icon">
                  <Icon name={v.icon as never} size={28} />
                </div>
                <h3>{v.title}</h3>
                <p>{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  )
}
